export default __webpack_public_path__ + "static/media/Rectangle 53(5).43150a7c.png";